module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 78
// module chunks = 0